export enum TagTypeFriendlyIds {
  facility = "facility",
  unit = "unit",
  hub = "hub",
  room = "room",
  bed = "bed",
  specialty = "specialty",
  subSpecialty = "subspecialty",
  qualifier = "qualifier",
  deviceType = "device-type",
  device = "device",
  cancelReason = "cancel-reason",
  consultPriority = "consult-priority",
  languages = "languages",
  templateSections = "templateSections",
  teamType = "team-type",
  serviceLocation = "service-location",
  layout = "layout",
  translationService = "translationService",
  permissions = "permissions",
  permissionsGroup = "permissions-group",
  modules = "modules",
  videoConferencingService = "video-conferencing-service",
  visitType = "visitType",
  supportModule = "support-module",
  topic = "topic",
  issueCategory = "issue-category",
  location = "location",
  callerRole = "caller-role",
  resolutionOutcomes = "resolution-outcomes",
  camera = "camera",
  messageType = "message-type"
}
